import { init } from "@marko/runtime-tags/dom";
import "./contact.marko";
import "../../src/routes/+layout.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/contact-section/index.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/contact-section/index.marko";
export default () => init();